import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { UserInfoContext } from '@/components/subcomponents/user/user-info';
import {
  accountManagerSeesAllTicketsSelector,
  accountPrivateConversationsEnabledSelector,
  accountSoloConversationsEnabledSelector,
} from '@/redux/app/selectors/settings';

export const useSoloModeCheck = () => {
  const { canManage, admin } = useContext(UserInfoContext);
  const soloConversationsEnabled = useSelector(accountSoloConversationsEnabledSelector);
  const privateConversationsEnabled = useSelector(accountPrivateConversationsEnabledSelector);
  const accountManagerSeesAllTickets = useSelector(accountManagerSeesAllTicketsSelector);

  if (soloConversationsEnabled) return !canManage || !accountManagerSeesAllTickets;
  if (privateConversationsEnabled) return !canManage && !admin;
  return false;
};
